import { getList, getAllList, addPhrase, updatePhrase, delPhrase } from '@/api/risk/quick';

const successCode = 0;

const quick = {
  name: 'globalQuick',
  namespaced: true,
  actions: {
    // 列表
    List(state, params) {
      return new Promise((resolve, reject) => {
        getList(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetAllList(state, params) {
      return new Promise((resolve, reject) => {
        getAllList(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 新增
    AddPhrase(state, params) {
      return new Promise((resolve, reject) => {
        addPhrase(params)
          .then((response) => {
            const { code, msg } = response;
            const data = {
              success: true,
            };
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 编辑
    UpdatePhrase(state, params) {
      return new Promise((resolve, reject) => {
        updatePhrase(params)
          .then((response) => {
            const { code, msg } = response;
            const data = {
              success: true,
            };
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 删除
    DelPhrase(state, params) {
      return new Promise((resolve, reject) => {
        delPhrase(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 快捷回复-已开启
    async fetchEnableQuickList() {
      const params = { state: 1 };
      const resData = await getList(params);
      if (resData.code) {
        return [];
      }
      resData.data.list = [{ id: 0, replyPhrase: '不限' }, ...resData.data.list];
      return resData.data.list;
    },
  },
};

export default quick;
